import { render, staticRenderFns } from "./AreasBarChart.vue?vue&type=template&id=3fa8afec&scoped=true&"
import script from "./AreasBarChart.vue?vue&type=script&lang=ts&"
export * from "./AreasBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./AreasBarChart.vue?vue&type=style&index=0&id=3fa8afec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8afec",
  null
  
)

export default component.exports